'use client'

import { useEffect } from 'react'
import styles from './EmbedDataWrapper.module.scss'

declare global {
  interface Window {
    addedDwResizer: boolean
  }
}

export const useDwResizer = (src: string) => {
  useEffect(() => {
    if (!window.addedDwResizer) {
      window.addEventListener('message', function (e) {
        if (e.origin !== new URL(src).origin) return
        if (void 0 !== e.data['datawrapper-height']) {
          const t = document.querySelectorAll('iframe')
          for (const a in e.data['datawrapper-height']) {
            for (let r = 0; r < t.length; r++) {
              if (t[r].contentWindow === e.source && t[r].style.height !== e.data['datawrapper-height'][a] + 'px') {
                t[r].style.height = e.data['datawrapper-height'][a] + 'px'
              }
            }
          }
        }
      })
      window.addedDwResizer = true
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

const EmbedDatawrapper = ({ src }: { src: string }) => {
  useDwResizer(src)

  return <iframe className={styles.iframe} src={src} title="Datawrapper" loading="lazy" scrolling="no" />
}

export default EmbedDatawrapper
